import flagsmith from "@flagsmith/flagsmith";
import { FlagsmithContextType } from "@flagsmith/flagsmith/react";
import { warnOnError } from "./warn-on-error";

/**
 * Initialise Flagsmith with the provided options. Flag fetch failures (network issues, adblockers etc.) are logged
 * rather than thrown so the application can continue with default flag values.
 * @param {object} options - The options for the Flagsmith init function.
 */
export const initialiseFeatureFlags = (options: Partial<FlagsmithContextType["options"]>) => {
    return flagsmith
        .init({
            environmentID: process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID || "",
            onError: warnOnError,
            ...options,
        })
        .catch(warnOnError);
};
